import {useEffect} from 'react';

import {useContentDiscoveryStore} from '../ContentDiscoveryStore.react';

export const useDraftSubscription = () => {
  // oxlint-disable-next-line react/react-compiler -- zustand store static API (getState/subscribe), not a hook call
  const store = useContentDiscoveryStore.getState();
  const {draft} = store;

  useEffect(() => {
    const unsubscribers = [
      useContentDiscoveryStore.subscribe(
        (state) => state.assignment.assignment,
        (initialAssignment) => {
          if (initialAssignment && !draft.draftName) {
            draft.setDraftName(initialAssignment.getName());
          } else if (draft.draftName) {
            draft.setDraftName(draft.draftName);
          }
        }
      )
    ];

    return () => {
      unsubscribers.forEach((unsub) => unsub());
    };
  }, []);
};
